export default __webpack_public_path__ + "static/media/kadra_jula.becc1f39.jpeg";